module.exports = __webpack_public_path__ + "img/compu-minutes-editor.93c80207.svg";